import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import ProjectCard from "../../launchpad/card/ProjectCard";
import LaunchpadEmtyCard from "../../launchpad/card/LaunchpadEmtyCard";
import { CampaignType } from "../../../type";
import { ProjectEnum } from "../../../type/enum";

const ProjectList = ({
  projectList,
  loading,
  filter,
}: {
  projectList: CampaignType[];
  loading: boolean;
  filter: ProjectEnum;
}) => {
  return (
    <div className="wrap-item-opening opening-new">
      {loading ? (
        <div className="spin-loading">
          <Spin
            className="w-100"
            size="large"
            indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />}
          />
        </div>
      ) : projectList.length === 0 ? (
        filter === ProjectEnum.UPCOMING ? (
          <div className="columns">
            <LaunchpadEmtyCard />
            <div className="colum w-4">
              <img
                style={{ width: "100%", height: "100%" }}
                src="./images/empty-project2.png"
                alt=""
              />
            </div>
          </div>
        ) : (
          <>
            <div className="empty-data-opening">
              <img src="./images/no-home-live.svg" alt="" />
            </div>
            <div className="empty-data-opening-mo">
              <div className="empty-data-complete">
                <div className="empty-data">
                  <div className="empty-end">
                    <img
                      style={{ width: "90px", height: "80px" }}
                      src="/images/empty-live-mo.png"
                      alt=""
                    />
                    <p>More projects are coming soon</p>
                  </div>
                </div>
              </div>
            </div>
          </>
        )
      ) : (
        <div className={`mt-5 flex flex-wrap justify-center`}>
          {projectList.map((project) => (
            <div className="w-full sm:w-1/2 lg:w-1/3">
              <ProjectCard key={project.id} cardData={project} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProjectList;
